import { Alert } from "antd";
import { apiGetCertificateAlerts } from "helpers/api/master/certificates";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import "./styles.scss";

// Dải cảnh báo hạn chứng chỉ TLS, hiện cho quản trị viên ở mọi màn hình.
//
// Đây là kênh thông báo duy nhất và nó chỉ tồn tại khi có người đăng nhập, nên
// ngưỡng phía server đặt rộng thay vì sát hạn: cửa sổ càng rộng thì khả năng có
// người nhìn thấy kịp càng cao.
const DISMISS_PREFIX = "CERT_ALERT_DISMISSED";

const todayKey = () => new Date().toISOString().slice(0, 10);

const CertificateAlert = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [alerts, setAlerts] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  useEffect(() => {
    let cancelled = false;
    apiGetCertificateAlerts()
      .then((response) => {
        if (!cancelled) setAlerts(response?.data || []);
      })
      .catch(() => {
        // Không lấy được thì im lặng: đây là thông tin phụ, không đáng chen một
        // thông báo lỗi vào mọi màn hình.
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Đóng chỉ có tác dụng trong ngày — hôm sau hiện lại, vì hạn vẫn đang trôi.
  const dismissKey = (alert) => `${DISMISS_PREFIX}_${alert.host}_${todayKey()}`;

  const isDismissed = (alert) => {
    if (dismissed.includes(alert.host)) return true;
    try {
      return localStorage.getItem(dismissKey(alert)) === "1";
    } catch (error) {
      return false;
    }
  };

  const dismiss = (alert) => {
    try {
      localStorage.setItem(dismissKey(alert), "1");
    } catch (error) {
      // Trình duyệt chặn localStorage thì vẫn ẩn được trong phiên hiện tại.
    }
    setDismissed([...dismissed, alert.host]);
  };

  const messageOf = (alert) => {
    if (alert.level === "unknown") {
      return t("certificate.alert_unknown", { host: alert.host });
    }
    if (alert.level === "expired") {
      return t("certificate.alert_expired", { host: alert.host });
    }
    return t("certificate.alert_expiring", {
      host: alert.host,
      days: alert.days_until_expiry,
      date: alert.not_after
        ? new Date(alert.not_after).toLocaleDateString("ja-JP")
        : "",
    });
  };

  const visible = alerts.filter((alert) => !isDismissed(alert));
  if (visible.length === 0) return null;

  return (
    <div className="certificate-alert-bar">
      {visible.map((alert) => (
        <Alert
          key={alert.host}
          banner
          type={alert.level === "warning" ? "warning" : "error"}
          showIcon
          closable
          onClose={() => dismiss(alert)}
          message={
            // Gộp nội dung và liên kết vào một hàng để dải cảnh báo mỏng,
            // không chiếm chỗ của nội dung chính bên dưới.
            <div className="certificate-alert-row">
              <span className="certificate-alert-text">{messageOf(alert)}</span>
              <span
                className="certificate-alert-link"
                onClick={() => history.push("/admin/certificate")}
              >
                {t("certificate.alert_action")}
              </span>
            </div>
          }
        />
      ))}
    </div>
  );
};

export default CertificateAlert;
